import { useEffect, useState } from 'react'
import { Button } from '../../components/ui/button'
import { styles } from '../../styles/tailwind-config'
import { AlertTriangle, AlertTriangleIcon, ArrowLeftIcon, Loader2 } from 'lucide-react'
import { Label } from '../../components/ui/label'
import { Input } from '../../components/ui/input'
import { Link, useSearchParams } from 'react-router-dom'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from '../../lib/axios'
import Spinner from '../../components/ui/spinner'
import boxlogo from '../../assets/logo/logo-mountq-full.svg'
import security from '../../assets/illustrations/technicians-people.svg'

import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'


const ResetPassword = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const code = searchParams.get('code')

    const {t, i18n} = useTranslation()

    const [password, setpassword] = useState('');

    const { isLoading:isLoadingRequest, isSuccess:isRequestValid, isError:isRequestInvalid } = useQuery({
        queryKey: [`password-validate-${code}`],
        queryFn: async () => {
            const { data } = await axios.get(`password/validate`, { params:{ code:code } })
            return data
        }
    })

    const { mutate:handleResetPassword, reset:resetRequestPassword, isPending, isError, isSuccess } = useMutation({
        mutationFn: async () => {
            const { data } = await axios.post(`password/reset`, { 
                code: code,
                password:password
            })
            console.log(data)
            toast.success('Wachtwoord succesvol ingesteld!', { id:'handleResetPassword' })
            return true
        },
        onError: (e) => {
            console.log(e)
            toast.error('Er is een fout opgetreden', { id:'handleResetPassword' })
            setTimeout(()=>{resetRequestPassword()}, 2000)
        }
    })

  return (
    <div className='flex flex-col items-center justify-between h-dvh max-h-dvh w-dvw bg-slate-100'>
        <div className='flex items-center gap-1 py-4'>
            <img className='w-auto h-12' src={boxlogo} alt="MountQ logo"/>
        </div>

        <div className='flex flex-col items-center w-full'>
            <img className='w-full max-w-xs translate-y-10' src={security} alt="MountQ security"/>
            <div className='z-10 flex flex-col items-center w-full max-w-3xl gap-6 p-10 bg-white shadow-2xl md:p-20 rounded-t-3xl'>
                {isLoadingRequest &&
                <div className='flex items-center justify-center gap-2'>
                    <Loader2 className='w-4 h-4 animate-spin'/>
                    <p className='text-sm font-medium'>Even geduld... We controleren uw aanvraag</p>
                </div>
                }

                {isRequestInvalid &&
                <div className='flex flex-col items-center justify-center gap-2'>
                    <div className='flex items-center justify-center gap-2'>
                        <AlertTriangleIcon className='w-4 h-4'/>
                        <p className='text-sm font-medium'>Helaas! Uw aanvraag is niet (meer) geldig</p>
                    </div>
                    <Link to="/login">
                        <Button>
                            Terug naar inlogscherm
                        </Button>
                    </Link>
                </div>
                
                }

                {isRequestValid && 
                <>
                    <div className='flex justify-between w-full'>
                        <Link to="/login" className='flex items-center justify-center gap-2 p-2 text-sm font-medium rounded-sm w-fit bg-neutral-100'><ArrowLeftIcon className='w-4 h-4'/>Terug naar inlogscherm</Link>
                    </div>
                    <h1 className={`${styles.h1} w-full`}>Wachtwoord opnieuw instellen</h1>
                    <div className='w-full'>
                        <Label htmlFor='password'>Nieuw wachtwoord</Label>
                        <Input value={password} onChange={({currentTarget})=>{setpassword(currentTarget.value)}} onKeyDown={(e)=>{if(e.key === 'Enter'){ handleResetPassword() }}} placeholder={`Wachtwoord...`} id='password' type='password'/>
                    </div>
                    {
                        isSuccess
                        ?
                        <Link to="/login">
                            <Button>
                                Terug naar inlogscherm
                            </Button>
                        </Link>
                        :
                        <Button onClick={()=>{handleResetPassword()}} disabled={isPending || isError} className='w-full gap-2'>
                            {isPending && <Spinner className='w-4 h-4'/>}
                            {isError && <AlertTriangle className='w-4 h-4'/>}
                            Wachtwoord instellen
                        </Button>
                    }
                </>
                }
                
            </div>
        </div>
    </div>
  )
}

export default ResetPassword